import Vue from 'vue';

class SignWorkflowApi {
  /**
   * Method used to find sign workflows by organisation id.
   *
   * @param {int} organizationId The given identifier.
   *
   * @returns {Promise} The result in a promise.
   */
  static findByOrgId(organizationId) {
    return Vue.$http.post('/sign-workflow-templates', { orgId: organizationId });
  }

  /**
   * Method used to update an existing sign workflow.
   *
   * @param {Object} signWorkflow The given signWorkflow.
   *
   * @returns {Promise} The result in a promise.
   */
  static update(signWorkflow) {
    return Vue.$http.put(`/sign-workflow-template/${signWorkflow.id}`, signWorkflow);
  }

  /**
   * Method used to create a sign workflow.
   *
   * @param {Object} signWorkflow The given signWorkflow.
   *
   * @returns {Promise} The result in a promise.
   */
  static create(signWorkflow) {
    return Vue.$http.post('/sign-workflow-template', signWorkflow);
  }

  /**
   * Method used to delete an existing sign workflow.
   *
   * @param {int} signWorkflowId The given signWorkflowId.
   *
   * @returns {Promise} The result in a promise.
   */
  static delete(signWorkflowId) {
    return Vue.$http.delete(`/sign-workflow-template/${signWorkflowId}`);
  }
}

export default SignWorkflowApi;



// WEBPACK FOOTER //
// ./src/api/SignWorkflowApi.js